import { render, staticRenderFns } from "./parentHistoryServicerList.vue?vue&type=template&id=a5e8fa3c&"
import script from "./parentHistoryServicerList.vue?vue&type=script&lang=js&"
export * from "./parentHistoryServicerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports